import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Endpoints} from "../../customs/endpoints";
import {CommonResponse} from "../../customs/_models/Response";
import {Observable, catchError, of} from "rxjs";
import {OT_DTO} from "../../customs/_models/OT_DTO";
import {AnalyseDTO} from "../../customs/_models/analyse.dtos";
import {DialogService} from "../../customs/_modal/dialog.service";
import {SampleDTO} from "../../customs/_models/sampleDTO";
import { AccDTO } from '../../customs/_models/AccDTO';
import { MethodStepDTO } from '../../customs/_models/method-step.dto';
export interface MethodeDTO {
  id: number;
  code: string;               // ex: ICP-MS-01
  name: string;               // ex: ICP-MS
  norme?: string;             // norme optionnelle
  stepIds: MethodStepDTO[];     // toutes les étapes associées
  versions: VersionDTO[];     // toutes les versions associées
}
export interface VersionDTO {
  id: number;
  numero: number;              // numéro de version
  description?: string;
  dateEdition?: string;        // ISO string
  stepIds: MethodStepDTO[];      // les étapes associées à cette version
}

export interface MethodStepFieldConfig {
  valeurApplicable: boolean;
  uniteApplicable: boolean;
  commentaireApplicable: boolean;
  dateApplicable: boolean;
  statutApplicable: boolean;
  realiseApplicable: boolean;
}

export interface MethodStep {
  id: number;
  titre: string;
  description: string;
  fieldConfig?: MethodStepFieldConfig;
}

@Injectable({
    providedIn: 'root'
})
export class MethodeService {

      constructor(private http: HttpClient, private endpoints: Endpoints) { }

  getAllMethodes(): Observable<MethodeDTO[]> {
    return this.http.get<MethodeDTO[]>(`${this.endpoints.methode_base_endpoint}`);
  }

  deleteMethode(id: number): Observable<void> {
    return this.http.delete<void>(`${this.endpoints.methode_base_endpoint}/${id}`);
  }
  updateMethode(dto: MethodeDTO): Observable<MethodeDTO> {
    // ⚠️ On suppose que ton endpoint backend suit REST : PUT /methodes/{id}
    return this.http.put<MethodeDTO>(
      `${this.endpoints.methode_base_endpoint}/${dto.id}`,
      dto
    );
  }
  createMethode(methode: MethodeDTO): Observable<MethodeDTO> {
    return this.http.post<MethodeDTO>(`${this.endpoints.methode_base_endpoint}`, methode);
  }
}
